module.exports = __webpack_public_path__ + "static/media/black_logo.6afd7471.webp";